import moment from "moment";
import {
  IChatbotContact,
  IChatContactMetadata,
} from "../../../redux/chatbot/chatbot.types";

export const fetchChatContactsAsync = () => {
  return "";
};

export const reorderChatContactsByLastMessageAsync = (
  contacts: IChatbotContact[],
) => {
  return [...contacts].sort(
    // (a, b) => moment(b.create_ts).valueOf() - moment(a.create_ts).valueOf()
    (a, b) => moment(b.insert_ts).valueOf() - moment(a.insert_ts).valueOf(),
  );
};

export const shouldHideContactNumber = (
  meta: IChatContactMetadata,
  roleValue: string,
) => {
  // console.log("roleValue...", roleValue);
  // console.log("meta...", meta);

  // If access control not defined → always show
  if (!meta?.RECEPIENT_NUMBER_ACCESSED_BY) {
    return false;
  }

  const allowedRoles = meta.RECEPIENT_NUMBER_ACCESSED_BY.split(",").map(
    (role) => role.trim(),
  );

  const didRoleExistsInMeta = allowedRoles.includes(roleValue);

  console.log("didRoleExistsInMeta...", didRoleExistsInMeta);

  // Hide if role NOT present
  return !didRoleExistsInMeta;
};

export const shouldHideAssigneeBtn = (roleValue: string) => {
  console.log("roleValue...", roleValue);

  if (!roleValue) {
    return false;
  }

  const allowedRoles = ["OWNER", "ADMIN", "WHATSAPP_ADMIN"];

  const didRoleExistsInAllowedRoles = allowedRoles.includes(roleValue);

  console.log("didRoleExistsInAllowedRoles...", didRoleExistsInAllowedRoles);

  // Hide if role NOT present
  return didRoleExistsInAllowedRoles;
};

// Helper function to mask restricted messages
export const maskRestrictedMessage = (
  text: string,
  maskLength?: number,
): string => {
  if (!text) return "";

  // If max mask length is provided
  if (maskLength !== undefined) {
    const length = text.length;

    // We want to keep the country code (assumed first 3 characters, e.g. "+91") visible.
    // Then mask the next `maskLength` characters, and keep the rest visible.
    const startKeep = 3;
    
    if (length <= startKeep) {
      return "X".repeat(length);
    }

    const actualMaskLength = Math.min(maskLength, length - startKeep);
    const visibleStart = text.slice(0, startKeep);
    const maskedPart = "X".repeat(actualMaskLength);
    const visibleEnd = text.slice(startKeep + actualMaskLength);

    return `${visibleStart}${maskedPart}${visibleEnd}`;
  }

  // Default behavior (your previous logic)
  return `${text[0]}${"X".repeat(text.length > 5 ? 10 : text.length)}${text.length > 5 ? "..." : ""
    }`;
};
